import {mapState} from "vuex";

export default {
  computed: {
    ...mapState({
      brtActId: state => state.user.brtActId
    }),
  },
  beforeRouteEnter(to, from, next){
    next(_vm=> {
      _vm.$bus.$on('next', ()=>_vm.saveData('next'))
      _vm.$bus.$on('finish', ()=>_vm.saveData('finish'))
    })
  },
  beforeRouteLeave(to, from, next) {
    this.$bus.$off('next')
    this.$bus.$off('finish')
    next()
  }
}
